<template>
  <div>
    <div class="background-header">
      <div class="container">
        <div class="row">
          <div class="col-md-7 col-lg-6 left-content">
            <div>
              <h2><strong>Todos tus puntos <br> en una sola cuenta</strong></h2>
              <p class="txt-home">Con una sola cuenta acumula puntos en los comercios afiliados para obtener grandes descuentos y beneficios o <strong>¡hasta compras gratis!</strong></p>
              <div style="display: flex">
                <router-link to="/login">
                  <n-button type="info" round>
                    <strong>Login para usuarios</strong>
                  </n-button>
                </router-link>
                <n-button type="info" link @click="modals.classic = true"><strong>Registrate</strong></n-button>
                <modal :show-close="true" :show.sync="modals.classic" modal-classes="modal-lg" header-classes="justify-content-center">
                <h4 slot="header" class="title title-up text-color-blue text-center"><strong>Registra tu cuenta Loyalty Refunds</strong></h4>
                <registro></registro>
              </modal>
              </div>
            </div>
          </div>
          <div class="col-md-5">
            <div class="right-content">
              <img class="img-home" src="../assets/assets_loyalty/assets-18.png" alt="" />
            </div>
          </div>
        </div>
      </div>
      <div class="space-70"></div>
    </div>
    <p ref="Who"></p>
    <comercio-section id="comercio"></comercio-section>
    <contact-section id="contact"></contact-section>
  </div>
</template>
<script>
import { Button, Modal } from '@/components';
import ComercioSection from './components/ComerciosSection';
import ContactSection from './components/ContactSection';
import Registro from './components/Registro'

export default {
  name: 'index',
  bodyClass: 'index-page',
  components: {
    Modal,
    Registro,
    ComercioSection,
    ContactSection,
    [Button.name]: Button
  },
  data() {
    return {
      modals: {
        classic: false,
      }
    }
  }
};
</script>
<style>
.left-content{
  margin-top: 180px;
}

.right-content{
  margin: 100px 0px 0px 40px;
}

.background-header{
  background-color: #B2B2B212;
}
.txt-home{
  text-align: justify;
}
@media screen and (min-width: 321px) and (max-width: 768px) { 
  .right-content{
    margin: 0px;
  }

  .left-content{
    margin-top: 180px;
  }
}
</style>
